import React from "react";
import { Form, Input } from "antd";
import { BiMap } from "react-icons/bi";

const RegisterAdressSuburb = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item name="subUrb" label="Suburb" rules={[]}>
      <Input
        prefix={<BiMap className="form-item-icon" />}
        placeholder="Suburb"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default RegisterAdressSuburb;
